import { Box, InputBase, Select, Skeleton } from '@mui/material';
import styled, { css } from 'styled-components';

export const StyledInput = styled(InputBase)`
    border: 1px solid ${(props) => (props.error ? props.theme.colors.error : props.theme.colors.border)};
    border-radius: 4px;

    .MuiInputBase-input {
        padding: 0.5rem 0.75rem;
    }
`;

export const StyledInputLoading = styled(Skeleton)`
    height: 41px;
    transform: none;
`;

export const StyledSelect = styled(Select)`
    .MuiInputBase-input {
        padding: 0.5rem 0.75rem;
    }
`;

export const StyledLabel = styled.label<{ isRequired?: boolean }>`
    font-size: 16px;
    color: ${(props) => props.theme.colors.text.secondary};

    &::before {
        content: "${(props) => (props?.isRequired ? '*' : '')}";
        color: ${(props) => props.theme.colors.required};
    }
`;

// Sharing these styles prevents the height of forms from shifting when an error occurs
const sharedStyles = css`
    font-size: 12px;
    line-height: 1.2;
    margin-top: 6px;
`;

export const StyledSubtext = styled.span`
    ${sharedStyles};
    opacity: 0.8;
`;

export const Error = styled(Box)`
    ${sharedStyles};
    color: ${(props) => props.theme.colors.error};
`;
